import { LanguageCode } from '@/services/ws-funnel/src/main/resources/rest-api';

import { LanguageKey } from 'src/types.ts';

export const LanguageKeyToLanguageCodeMap: Record<LanguageKey, LanguageCode> = {
  [LanguageKey.English]: LanguageCode.EN,
  [LanguageKey.German]: LanguageCode.DE,
  [LanguageKey.French]: LanguageCode.FR,
  [LanguageKey.Italian]: LanguageCode.IT,
};
